<div class="container">
    <div class="row">
        <div class="col-sm-6">
            <h5 class="performance-heading rps-heading-five">Performance</h5>
        </div>
    </div>
    <div class="row">
        <div class="col-6" *ngIf="overviewModel?.isETF">
            <p class="ytd-title rps-paragraph-two">YTD returns&nbsp;(MP)</p>
            <h4 class="ytd-data rps-heading-four" data-rpa-tag-id="overview-prf-ytd-mkt-pct">{{ overviewModel.ytdMarket | VMFPercent}}</h4>
            <ng-template #mdash>
                <h4 class="ytd-data rps-heading-four" data-rpa-tag-id="overview-prf-ytd-mkt-pct">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" data-rpa-tag-id="ytdPercentMarketDate">as of {{ overviewModel?.ytdAsOfDate | ESTPipe }}</p>
        </div>
        <div class="col-6" *ngIf="!overviewModel?.isETF">
            <p class="ytd-title rps-paragraph-two">YTD returns</p>
            <h4 *ngIf="overviewModel?.regular; else mdash" class="ytd-data rps-heading-four" data-rpa-tag-id="ytdPercent">{{ overviewModel.regular | VMFPercent}}</h4>
            <ng-template #mdash>
                <h4 class="ytd-data rps-heading-four" data-rpa-tag-id="ytdPercent">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" data-rpa-tag-id="ytdDate">as of {{ overviewModel?.ytdAsOfDate | ESTPipe }}</p>
        </div>
        <div class="col-6" *ngIf="overviewModel?.isMoneyMarket && overviewModel?.compoundYieldPct">
            <p class="ytd-title rps-paragraph-two"><a role="button" tabindex="0" class="link secYieldLink dialog-button" (click)="setDialogInfo('Compound yield','',''); performanceComponentModal.openModalDialog($event);" href="javascript:void(0)">Compound yield</a>
            </p>
            <h4 class="ytd-data rps-heading-four" *ngIf="overviewModel?.regular; else mdash">{{ overviewModel.compoundYieldPct | VMFPercent}}</h4>
            <ng-template #mdash>
                <h4 class="ytd-data rps-heading-four">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey">as of {{ overviewModel?.compoundYieldAsOfDate | ESTPipe }}</p>
          <c11n-modal-dialog
            modalId="performanceComponentModal"
            [headingText]="dialogTitle"
            #performanceComponentModal
          >
            <div c11n-modal-dialog-body>
              <ng-container *ngTemplateOutlet="simpleDialogContent"></ng-container>
            </div>
          </c11n-modal-dialog>
        </div>
        <div class="col-6 ytd-container" *ngIf="overviewModel?.isETF">
            <p class="ytd-title rps-paragraph-two">YTD returns&nbsp;(NAV)</p>
            <h4 *ngIf="overviewModel?.isETF" class="ytd-data rps-heading-four" data-rpa-tag-id="ytdPercentNAV">{{ overviewModel.regular | VMFPercent }}</h4>
            <ng-template #elseif>
                <h4 class="ytd-data rps-heading-four" *ngIf="overviewModel?.navPrice && overviewModel?.is529 || overviewModel?.isMutualFund; else mdash"> {{ overviewModel.navPrice }}</h4>
            </ng-template>
            <ng-template #mdash>
                <h4 class="ytd-data rps-heading-four" data-rpa-tag-id="ytdPercentNAV">&mdash;</h4>
            </ng-template>
            <p class="caption rps-paragraph-three rps-grey" data-rpa-tag-id="ytdPercentNAVDate">as of {{ overviewModel?.navPriceAsOfDate | ESTPipe }}</p>
        </div>
    </div>
  <ng-template #simpleDialogContent>
    <div>
      <p class="rps-paragraph-three" *ngIf="!SecyieldFlag">{{dialogBody}}</p>
      <p class="rps-paragraph-one" *ngIf="SecyieldFlag" [innerHTML]="dialogBody"></p>
    </div>
  </ng-template>
</div>

